import React from 'react';
import styles from './ActionProgressFailed.module.css';
import useTheme from 'config/useTheme';

const ActionProgressFailed = ({ message, details, onClose }) => {
    const { dark } = useTheme();
    return (
        <div className={`${styles.action_progress} ${dark ? styles.dark : ''}`}>
            <div className={styles.top_bar}>
                <button onClick={() => onClose()}>Close</button>
            </div>
            <div className={styles.main}>
                <div className={styles.bar}>
                    <div className={styles.label}>100%</div>
                </div>
                {message && <span>{message}</span>}
                {details && <span>Details: {details}</span>}
            </div>
        </div>
    )
}

export default ActionProgressFailed;